<template>
  <div id="main-box" class="page-content">

    <div class="integral_box">
      <ul class="integral_main">
        <li>
          <p class="integral_title">剩余积分</p>
          <p class="integral_count" v-text="integral"></p>
        </li>
        <li>
          <p class="integral_title">已使用积分</p>
          <p class="integral_count" v-text="consumptionTotal"></p>
        </li>
        <li>
          <p class="integral_title">套餐优惠</p>
          <p class="integral_count" v-text="integral+consumptionTotal-integralTotal"></p>
        </li>
        <li>
          <p class="integral_title">总积分</p>
          <p class="integral_count" v-text="integral+consumptionTotal"></p>
        </li>
      </ul>
    </div>

  	<div class="recharge_box">
  		<div class="recharge_hint">注：充值的积分可用于系统所有功能，不可提现和退款，请勿过量充值</div>
  		<ul class="recharge_list">
  			<li v-on:click="selectData(index)" :data-index="index" :class="{recharge_active:index==ix}" v-for="(item,index) in list" v-bind:key="index" v-text="'￥'+item.count+'（'+item.integral+'积分）'"></li>
  		</ul>
  		<div class="recharge_btnArr" style="margin:0;">
        <!-- <a v-on:click="create_pay_qr(1)">支付宝支付</a>
        <a v-on:click="create_pay_qr(2)">微信支付</a> -->
        <a href="https://heiling.yeeke.com/duiguo/user/register?flag=YUSCL" target="_blank">前往新地址</a>
      </div>
  	</div>

  	<div class="pay_box" v-if="isShow">
  		<div class="pay_box_main">
  			<div class="pay_box_title">{{CurrentAmount}}元充值套餐<img v-on:click="close_pay_box" class="pay_close" src="../../../static/images/close_01.png"></div>
  			<div class="pay_box_img">
  				<div v-if="te == 2" id="qrimg"></div>
          <div v-else><iframe scrolling="no" frameborder=0 width="260px" height="260px" :srcdoc="qr"></iframe></div>
  			</div>
  			<div class="pay_box_hint">请使用<i v-text="hint"></i>扫描二维码进行充值</div>
  		</div>
  	</div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

  </div>
</template>

<script>
var self;
var num = 1;
var TimerFun;
import axios from 'axios'
import Loading from '@/components/common/Loading.vue'
import Toast from '@/components/common/Toast.vue'
import QRCode from 'qrcodejs2'
export default {
  name: 'Recharge',
  components: {
    'K-Loading': Loading,
    'K-Toast': Toast,
  },
  data () {
    return {
      hint:"支付宝",
      loading:false,
      Toast:{
        state: false,
        type: 0,
        txt: null
      },
      isShow:false,
      ix:0,
      integral:0,
      CurrentAmount:0,
      consumptionTotal:0,
      integralTotal:0,
      list:[{
        count:10,
        integral:10
      },{
        count:50,
        integral:50
      },{
        count:100,
        integral:110
      },{
        count:500,
        integral:560
      },{
        count:1000,
        integral:1150
      }],
      te:1,
      qr:null
    }
  },
  mounted () {
    self = this;
    self.SetNavActive("货代",self.$route.name);
    self.get_integral();
  },
  beforeDestroy () {
    clearTimeout(TimerFun);
  },
  methods:{
    ToastFun (type,txt) {
      self.Toast.state = true;
      self.Toast.type = type;
      self.Toast.txt = txt;
    },
    ChangeToast () {
      self.Toast.state = false;
    },
    qrcode(qr) {
      setTimeout(() => {
        let qrcode = new QRCode("qrimg", {
          text: qr,
          width: 260, //图像宽度
          height: 260, //图像高度
        });
        qrcode.clear(); //清除二维码
        qrcode.makeCode(qr); //生成另一个新的二维码
      }, 500);
    },
    selectData (ix) {
    	this.ix = ix;
    },
    close_pay_box () {
    	this.isShow = false;
    },
    create_pay_qr (te) {
      self.te = te;
      let count = this.list[this.ix].count;
      var url = "/create_pay_qr_by_ali/";
      self.hint = "支付宝";
      if(te == 2){
        url = "/create_pay_qr/";
        self.hint = "微信";
      }
      self.CurrentAmount = count;
      self.loading = true;

      let param = new URLSearchParams()
      param.append('count', count)
      axios({
        method: 'post',
        url: self.GetServerUrl() + url,
        data:param,
        headers: {'token': localStorage.getItem("ExShopee_token")}
      }).then(function(response) {
        self.isShow = true;

        //返回数据处理
        self.ReturnFuntion(self,response,function(datas){
          num = 1;  //重置检测次数
          clearTimeout(TimerFun); //清除之前定时器
          if(te == 1){
            self.qr = datas.qr;
          }else{
            self.qrcode(datas.qr);  //生成二维码
          }
          self.wx_pay_status(datas.order_id); //支付状态检测
        },false,true);

      }).catch(function(error) {
        self.loading = false;
        self.ToastFun(2,error);  //弹窗提醒
      })
    },
    wx_pay_status (oid) {
        let param = new URLSearchParams()
        param.append('oid', oid)
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/wx_pay_status/",
          data:param,
          headers: {'token': localStorage.getItem("ExShopee_token")}
        }).then(function(response) {
          var json = response.data;
          if (json.code == 200) {
            self.isShow = false;
            self.ToastFun(0,json.msg);  //弹窗提醒
            self.get_integral();
          } else if (json.code == 401) {
            self.GoToPage("/"); // 路由跳转
          } else {

            //支付未完成轮巡检测
            TimerFun = setTimeout(function(){
              num++
              self.wx_pay_status(oid);
            },3000)
            if(num == 500){
              clearTimeout(TimerFun)
            }

          }
        }).catch(function(error) {
          console.log(error);
        })
    },
    get_integral() {
      axios({
        method: 'post',
        url: self.GetServerUrl() + "/get_integral/",
        headers: {'token': localStorage.getItem("ExShopee_token")}
      }).then(function(response) {

        //返回数据处理
        self.ReturnFuntion(self,response,function(datas){
          if(datas.integral){
            self.integral = datas.integral;
          }else{
            self.integral = 0;
          }
          if(datas.consumptionTotal){
            self.consumptionTotal = datas.consumptionTotal;
          }else{
            self.consumptionTotal = 0;
          }
          if(datas.integralTotal){
            self.integralTotal = datas.integralTotal;
          }else{
            self.integralTotal = 0;
          }
        });

      }).catch(function(error) {
        console.log(error);
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.integral_main{
  overflow: hidden;
  padding:0 20px 20px 20px;
}
.integral_main li{
  float: left;
  padding:20px;
  margin-top:20px;
  background-color: #FFF;
  margin-right: 30px;
  width: 230px;
  cursor: pointer;
  border-radius: 5px;
  border-top:2px solid #42B8F1;
	box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}
.integral_main li:hover{
	box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);
}
.integral_main li:last-child{
  margin-right: 0;
}
.integral_title{
  color:#555;
}
.integral_count{
  font-size:30px;
  padding:25px 0;
  color:#FF6C60;
  text-align: center;
}
.recharge_hint{
	padding:10px 0 0 20px ;
	color:#F00;
  font-size: 16px;
  font-weight: 900;
	font-family: Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,SimSun,sans-serif;
}
.recharge_list{
	overflow: hidden;
	padding-bottom:20px;
}
.recharge_list li{
	float: left;
	margin-top: 20px;
	margin-left:20px;
	border:1px solid #F3F3F3;
	padding: 15px 20px;
	border-radius: 5px;
	cursor: pointer;
	background-color: #FFF;
}
.recharge_list li:hover{
	box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
}
.recharge_active{
	color:#409eff;
	border:1px solid #409eff !important;
	box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
}
.recharge_btn:hover{
	opacity: 0.9;
	cursor: pointer;
}
.recharge_btnArr {
  overflow: hidden;
	margin:0 20px 20px 20px;
}
.recharge_btnArr a{
	display: table;
  float: left;
	color:#FFF;
	padding:12px 30px;
	border-radius: 5px;
  cursor: pointer;
}
.recharge_btnArr a:hover{
  opacity: 0.95;
}
.recharge_btnArr a:first-child{
	background-color: #409eff;
}
.recharge_btnArr a:last-child{
	background-color: #28A745;
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/logistics/Recharge.vue